import { render } from "./Service.vue?vue&type=template&id=2b065141"
const script = {}

import exportComponent from "D:\\job\\guobao\\guobao-ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__